import React from 'react';
import PropTypes from 'prop-types';
import SocialIcon from '../Icons/SocialIcons';
import classes from '../Icons/SocialIcons/SocialIcons.module.scss';

const SocialLinks = ({ socialLinks, iconClass }) => {
  return (
    <div className={classes.socialLinksBlock}>
      {socialLinks.length > 0 &&
        socialLinks.map(socialLink => (
          <div key={socialLink.type} className={classes.linkesBlock}>
            <SocialIcon iconClass={iconClass} url={socialLink.link} type={socialLink.type} />
          </div>
        ))}
    </div>
  );
};

SocialLinks.propTypes = {
  socialLinks: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string.isRequired,
      type: SocialIcon.propTypes.type,
    }).isRequired,
  ),
};
SocialLinks.defaultProps = {
  socialLinks: [],
};

export default SocialLinks;
